import { render } from "./xAppsPage.vue?vue&type=template&id=d184a824&scoped=true"
import script from "./xAppsPage.vue?vue&type=script&lang=js"
export * from "./xAppsPage.vue?vue&type=script&lang=js"

import "./xAppsPage.vue?vue&type=style&index=0&id=d184a824&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d184a824"]])

export default __exports__